import React, {useState} from 'react';
import {classes, style} from './doppe-action-type-paid-message-widget.st.css';
import {DoppeActionType} from '../../../client-server-common/doppe-action-types/doppe-action-type';
import {
    DoppeHideableValue,
    doppeHideableValueGetVisibleValue,
    doppeHideableValueIsHidden
} from '../../../client-server-common/types/doppe-hideable-value';
import {DoppeActionTypePaidMessage} from '../doppe-action-type-paid-message';
import {CommonClasses, FlexLayout} from '@wix/devzai-common-client';
import {
    DoppeActionTypeWidgetInnerTitle
} from '../../../components/doppe-action-type-widget-inner-title/doppe-action-type-widget-inner-title';
import {
    DoppeActionTypeWidgetInnerDescription
} from '../../../components/doppe-action-type-widget-inner-description/doppe-action-type-widget-inner-description';
import {doppeActionPriceGetFormattedPrice} from '../../../client-server-common/types/doppe-action-price';
import {DoppePageMediaView} from '../../../components/doppe-page-media-view/doppe-page-media-view';
import {assertDefined, HtmlObjectResizeMode} from '@wix/devzai-utils-common';
import {
    BymoPageViewerMode,
    useBymoPageViewerContext
} from '../../../components/bymo-page-viewer-context/bymo-page-viewer-context';
import {
    DoppeActionCheckoutView
} from '../../doppe-actions-common/doppe-action-checkout-view/doppe-action-checkout-view';
import {IDoppeViewerActionContext} from '../../../doppe-sdk';
import {ThankYouView} from '../../doppe-actions-common/doppe-action-thank-you-view/thankyou-view';
import {useDoppeViewerClientServices} from '../../../client/doppe-user-app/doppe-viewer-client-services';
import {
    DoppeActionTypeWidgetInnerButton
} from '../../../components/doppe-action-type-widget-inner-button/doppe-action-type-widget-inner-button';
import {DoppeActionLayout} from '../../../client-server-common';
import {
    DoppeViewerFormFieldsGroup
} from '../../../components/doppe-viewer-form-fields-group/doppe-viewer-form-fields-group';
import {
    DoppeActionWidgetTextArea
} from '../../../components/doppe-action-widget-text-area/doppe-action-widget-text-area';
import {
    DoppeViewerModalPanel,
    DoppeViewerModalPanelLayout
} from '../../../components/doppe-viewer-modal-panel/doppe-viewer-modal-panel';
import {
    DoppeViewerModalPanelHeader
} from '../../../components/doppe-viewer-modal-panel-header/doppe-viewer-modal-panel-header';
import {DoppeViewerScrollView} from '../../../components/doppe-viewer-scroll-view/doppe-viewer-scroll-view';
import {
    DoppeViewerModalPanelSection
} from '../../../components/doppe-viewer-modal-panel-section/doppe-viewer-modal-panel-section';
import {
    DoppeViewerLightboxModalPanel
} from '../../../components/doppe-viewer-lightbox-modal-panel/doppe-viewer-lightbox-modal-panel';
import {
    DoppeActionTypeWidgetContentLayoutNewWrapper
} from '../../../components/doppe-action-type-widget-content-layout-new-wrapper/doppe-action-type-widget-content-layout-new-wrapper';
import {
    DoppeActionTypeWidgetLayout
} from '../../../components/doppe-action-type-widget-layout/doppe-action-type-widget-layout';
import {useDoppeViewerLocales} from "../../../client/doppe-viewer-locales/doppe-viewer-locales";

export const DoppeActionTypePaidMessageWidget = React.memo(function DoppeActionTypeRequestsWidget(
    props: DoppeActionType.WidgetProps<DoppeActionTypePaidMessage.ActionSettings>
) {
    const {
        actionContext,

        className,
        ...htmlAttributes
    } = props;

    const actionSettings = actionContext.action.settings;


    return (
        <DoppeActionTypeWidgetLayout
            {...htmlAttributes}
            className={style(classes.root, {}, className)}
            actionContext={actionContext}
        >
            <DoppeActionTypePaidMessageWidgetInner
                actionSettings={{
                    ...actionSettings
                }}
                showConsent={actionSettings.showConsent}
                previewCheckoutButtonText={actionSettings.previewCheckoutButtonText}
                showAddressInput={actionSettings.showAddressInput}
                showPhoneInput={actionSettings.showPhoneInput}
                showEmailInput={actionSettings.showEmailInput}
                showConsentCheckbox={actionSettings.showConsentCheckbox}
                customConsentText={actionSettings.customConsentText}
                actionContext={actionContext}
                reportGoalAchieved={() => {
                    actionContext.reportGoalAchieved(
                        actionContext.action.id
                    );
                }}
                actionId={actionContext.action.id}
            />
        </DoppeActionTypeWidgetLayout>
    );
});


export const DoppeActionTypePaidMessageWidgetInner = React.memo(function DoppeActionTypePaidMessageWidgetInner(
    props: {
        actionSettings: DoppeActionTypePaidMessage.ActionSettings;
        actionContext: IDoppeViewerActionContext<any>;
        reportGoalAchieved: () => void;
        actionId: string;
        layout?: DoppeActionLayout;
        previewCheckoutButtonText: string,
        showPhoneInput: boolean,
        showEmailInput: boolean,
        showConsent: boolean,
        customConsentText: DoppeHideableValue<string>,
        showConsentCheckbox: boolean,
        showAddressInput: boolean,
    }
) {
    const {
        actionContext,
        actionSettings,
        reportGoalAchieved,
        previewCheckoutButtonText,
        showPhoneInput,
        showEmailInput,
        showConsent,
        customConsentText,
        showConsentCheckbox,
        showAddressInput,
    } = props;

    const {
        priceData,
        description,
        title,
        images,
    } = actionSettings;

    const price = {
        amount: assertDefined(priceData.actualPrice),
        currencyCode: priceData.currencyCode,
    }

    const createStripePaymentIntent = () =>
        actionContext.createStripePaymentIntent({
            price: price,
        });

    const pageViewerContext = useBymoPageViewerContext();
    const clientServices = useDoppeViewerClientServices();

    const doppeViewerLocales = useDoppeViewerLocales();

    const [message, setMessage] = useState('');
    const [checkoutFailed, setCheckoutFailed] = useState(false);

    return (
        <DoppeActionTypeWidgetContentLayoutNewWrapper
            fullWidthMainMedia={true}
            mainMedia={(images && images.length > 0) ? (
                <div
                    className={style(classes.eventImageContainer, {})}
                >
                    <DoppePageMediaView
                        className={style(classes.eventImage, {})}
                        mediaResource={images[0]}
                        layoutSpec={{autoHeight: true, maxHeight: 360}}
                        widthSpec={{contentRelativeWidth: 1}}
                        mediaResizeMode={HtmlObjectResizeMode.Cover}
                    />
                </div>
            ) : null}
            footer={
                <DoppeActionTypeWidgetInnerButton
                    className={style(classes.payButton, {})}
                    onClick={() => {
                        if (!message) {
                            setCheckoutFailed(true)
                        } else {
                            setCheckoutFailed(false)
                            actionContext.modalsController.showInnerModal({
                                content: ({modalController}) => (
                                    <DoppeViewerModalPanel
                                        className={style(classes.modal, FlexLayout.column.default)}
                                        mobileLayout={DoppeViewerModalPanelLayout.FullScreen}
                                        desktopLayout={DoppeViewerModalPanelLayout.InnerCentered}
                                    >
                                        <DoppeViewerModalPanelHeader
                                            title={previewCheckoutButtonText}
                                            dismissButtonCallback={() => {
                                                modalController.closeWindow();
                                            }}
                                        />
                                        <DoppeViewerScrollView
                                            className={style(classes.scrollView, FlexLayout.fillRemainingVerticalSpace)}
                                        >
                                            <DoppeViewerModalPanelSection
                                                className={style(classes.modalContent, FlexLayout.column.default)}
                                            >
                                                <div
                                                    className={style(classes.modalBody, FlexLayout.column.default)}
                                                >
                                                    <DoppeActionCheckoutView
                                                        onDone={({
                                                                     name,
                                                                     paymentIntentId,
                                                                     consent,
                                                                 }) => {
                                                            clientServices
                                                                .getApiClient()
                                                                .notifyPaidMessageSuccess({
                                                                    paymentIntentId,
                                                                    uouMessage: message,
                                                                    emailSubscriptionConsent: consent,
                                                                })
                                                                .catch(console.error);

                                                            setMessage('');

                                                            modalController.closeWindowImmediately();
                                                            reportGoalAchieved();

                                                            actionContext.modalsController.showInnerModal({
                                                                content: ({modalController}) => (
                                                                    <DoppeViewerLightboxModalPanel
                                                                        className={style(classes.modal, FlexLayout.column.default)}
                                                                        dismissButtonCallback={() => {
                                                                            modalController.closeWindow();
                                                                        }}
                                                                    >
                                                                        <DoppeViewerScrollView
                                                                            className={style(classes.scrollView, FlexLayout.fillRemainingVerticalSpace)}
                                                                        >
                                                                            <DoppeViewerModalPanelSection
                                                                                className={style(classes.modalContent, FlexLayout.column.default)}
                                                                            >
                                                                                <div
                                                                                    className={style(classes.thankyouContent, {})}
                                                                                >
                                                                                    <ThankYouView
                                                                                        onConfirm={() => {
                                                                                            modalController.closeWindow();
                                                                                        }}
                                                                                        name={name}
                                                                                        price={price}
                                                                                    />
                                                                                </div>

                                                                            </DoppeViewerModalPanelSection>
                                                                        </DoppeViewerScrollView>
                                                                    </DoppeViewerLightboxModalPanel>
                                                                )
                                                            })
                                                        }}
                                                        actionContext={actionContext}
                                                        showPhoneInput={showPhoneInput}
                                                        showEmailInput={showEmailInput}
                                                        showAddressInput={showAddressInput}
                                                        price={price}
                                                        createStripePaymentIntent={createStripePaymentIntent}
                                                        demoMode={pageViewerContext.mode !== BymoPageViewerMode.Live}
                                                        isCustomAmount={false}
                                                        showConsent={showConsent}
                                                        showConsentCheckbox={showConsentCheckbox}
                                                        consentText={doppeHideableValueGetVisibleValue(customConsentText, '')}
                                                    />
                                                </div>
                                            </DoppeViewerModalPanelSection>
                                        </DoppeViewerScrollView>
                                    </DoppeViewerModalPanel>
                                )
                            })
                        }
                    }}
                >
                    {
                        previewCheckoutButtonText
                    }
                </DoppeActionTypeWidgetInnerButton>
            }
        >
            <DoppeActionTypeWidgetInnerTitle
                className={style(classes.innerTitle, {})}
            >
                {title}
            </DoppeActionTypeWidgetInnerTitle>
            <DoppeActionTypeWidgetInnerDescription
                maxLines={3}
                className={style(classes.innerDescription, {})}
            >
                {description}
            </DoppeActionTypeWidgetInnerDescription>
            {
                !doppeHideableValueIsHidden(priceData) ?
                    <div
                        className={style(classes.price, {}, CommonClasses.ellipsis)}
                    >
                        {doppeActionPriceGetFormattedPrice(priceData)}
                    </div>
                    :
                    null
            }
            <div className={style(classes.separator, {})}/>
            <DoppeViewerFormFieldsGroup
                title={doppeViewerLocales['checkoutFormMessageFieldLabel']}
            >
                <DoppeActionWidgetTextArea
                    className={style(classes.textBox, {})}
                    placeholder={doppeViewerLocales['checkoutFormMessageFieldPlaceholder']}
                    value={message}
                    onTextChange={(value) => {
                        setMessage(value);
                    }}
                    hasError={checkoutFailed && !message}
                />
            </DoppeViewerFormFieldsGroup>
        </DoppeActionTypeWidgetContentLayoutNewWrapper>
    );
});